import axios from "axios";
import utils from "../utils";
import constants from "../utils/constants";
import config from "../utils/config";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: utils.config.authServices,
  timeout: 0,
});
const axiosInstanceThird = axios.create({
  baseURL: utils.config.attendanceService,
  timeout: 0,
});

const axiosInstanceCompanyRegistration = axios.create({
  baseURL: utils.config.authServices,
  timeout: 0,
});

const axiosInstancesecond = axios.create({
  baseURL: utils.config.userServices,
  timeout: 0,
});

const axiosInstancesecondForAdminProfileReg = axios.create({
  baseURL: utils.config.userServices,
  timeout: 0,
});

const axiosInstancesecondForAdminProfilePhoto = axios.create({
  baseURL: utils.config.userServices,
  timeout: 0,
});

axiosInstancesecondForAdminProfilePhoto.interceptors.request.use(
  (config) => {
    config.headers[constants.strings.authTokenLabel] = localStorage.getItem(constants.strings.newSessionLabel);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
)

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers[constants.strings.authTokenLabel] = localStorage.getItem(constants.strings.sessionLabel);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstanceThird.interceptors.request.use(
  (config) => {
    config.headers[constants.strings.authTokenLabel] = localStorage.getItem(constants.strings.sessionLabel);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstanceCompanyRegistration.interceptors.request.use(
  (config) => {
    config.headers[constants.strings.authTokenLabel] = localStorage.getItem(constants.strings.newSessionLabel);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (navigator.onLine) {
      if (error.response) {
        if (error.response.status === 503) {
          localStorage.setItem('status', error.status)
          window.open("/#" + constants.navigationLink.serverDown, "_self")
        }
        else if (error.response.status === 500) {
          localStorage.setItem('status', error.status)
          window.open("/#" + constants.navigationLink.serverError, "_self")
        }
        else if (error.response.status === 440) {
          localStorage.clear()
          toast.error(constants.constantsErrors.sessionExpire, { toastId: "error6" })
          window.open("/#" + constants.navigationLink.loginLink, "_self")
        }
        return Promise.reject(error.response);
      }
      else {
        toast.error(constants.constantsErrors.serverError, { toastId: "error6" })
      }
    }
    else {
      toast.error(constants.constantsErrors.internetErrorLabel, { toastId: "error6" })
    }
    return Promise.reject(error);
  }
);

axiosInstanceThird.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (navigator.onLine) {
      if (error.response) {
        if (error.response.status === 503) {
          localStorage.setItem('status', error.status)
          window.open("/#" + constants.navigationLink.serverDown, "_self")
        }
        else if (error.response.status === 500) {
          localStorage.setItem('status', error.status)
          window.open("/#" + constants.navigationLink.serverError, "_self")
        }
        else if (error.response.status === 440) {
          localStorage.clear()
          toast.error(constants.constantsErrors.sessionExpire, { toastId: "error6" })
          window.open("/#" + constants.navigationLink.loginLink, "_self")
        }
        return Promise.reject(error.response);
      }
      else {
        toast.error(constants.constantsErrors.serverError, { toastId: "error6" })
      }
    }
    else {
      toast.error(constants.constantsErrors.internetErrorLabel, { toastId: "error6" })
    }
    return Promise.reject(error);
  }
);

axiosInstancesecond.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (navigator.onLine) {
      if (error.response) {
        if (error.response.status === 503) {
          localStorage.setItem('status', error.status)
          window.open("/#" + constants.navigationLink.serverDown, "_self")
        }
        else if (error.response.status === 500) {
          localStorage.setItem('status', error.status)
          window.open("/#" + constants.navigationLink.serverError, "_self")
        }
        else if (error.response.status === 440) {
          localStorage.clear()
          toast.error(constants.constantsErrors.sessionExpire, { toastId: "error6" })
          window.open("/#" + constants.navigationLink.loginLink, "_self")
        }
        return Promise.reject(error.response);
      }
      else {
        toast.error(constants.constantsErrors.serverError, { toastId: "error6" })
      }
    }
    else {
      toast.error(constants.constantsErrors.internetErrorLabel, { toastId: "error6" })
    }
    return Promise.reject(error);
  }
);

axiosInstancesecond.interceptors.request.use(
  (config) => {
    config.headers["authToken"] = localStorage.getItem("session");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosInstancesecondForAdminProfileReg.interceptors.request.use(
  (config) => {
    config.headers["authToken"] = localStorage.getItem("newSession");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
async function companyProfile(body) {
  try {
    let response = await axiosInstance.post(
      constants.apiName.companyProfile,
      body
    );
    return response.data;
  } catch (error) {
    return error.data;
  }
}

async function googleAutoComplete(placeValue) {
  try {
    let url =
      config.googleAPI + placeValue + "&key=" + constants.apiName.apiKey;
    let response = await axios.get(url);
    return response.data.predictions;
  } catch (e) {
    return e;
  }
}

async function adminProfileRegistration(body) {
  try {
    let response = await axiosInstancesecondForAdminProfileReg.post(
      constants.apiName.adminProfile,
      body
    );
    return response.data;
  } catch (error) {
    return error;
  }
}

async function uploadAdminProfile(body) {
  const formData = new FormData()
  formData.append('files', body)
  try {
    let response = await axiosInstancesecondForAdminProfilePhoto.post(
      constants.apiName.uploadImg, formData);
    return response.data
  } catch (error) {
    return error.response
  }
}

async function addEmpProfileUpload(email , image) {
  
  try {
    const formData = new FormData();
        formData.append("files", image);
        formData.append("email", email);
    let response = await axiosInstancesecond.post(
      constants.apiName.uploadImg, formData);
    return response.data
  } catch (error) {
    return error;
  }
}
async function companyLogo(body) {

  try {
    let response = await axiosInstancesecond.post(
      constants.apiName.companyLogoUpload, body);
    return response.data
  } catch (error) {
    return error;
  }
}

async function officeTiming(body) {
  try {
    let response = await axiosInstanceCompanyRegistration.post(
      constants.apiName.officeTiming,
      body
    );
    return response;
  } catch (error) {
    return error.response;
  }
}

async function showEmployeeAttendance(body) {
  try {
    let response = await axiosInstance.get(
      constants.apiName.getAttendance,
      body
    );
    return response.data;
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getEmployeeStatus(obj) {
  try {
    let response = await axiosInstancesecond.get(
      `${constants.apiName.showEmployeeStatus}?name=${obj}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
}

async function logout() {
  try {
    let response = await axiosInstance.post(constants.apiName.logout)
    return response.data
  } catch (error) {
    return error.data
  }
}

async function addEmployee(body) {
  try {
    let response = await axiosInstance.post(constants.apiName.addEmployee, body)
    return response.data
  } catch (error) {
    return error;
  }
}

async function getEmployeeInformation(id) {
  try {
    let response = await axiosInstancesecond.get(
      `${constants.apiName.getEmployeeInformation}?id=${id}`
    );
    return response.data;
  } catch (error) {
    return error.data;
  }
}

async function adminProfileUpload(body) {
  try {
    const response = await axiosInstancesecond.post(
      constants.apiName.adminProfileUpload, body);
    return (response ? response.data : null)
  } catch (error) {
    return error.response
  }
}

async function changeLoginPassword(body) {
  try {
    const response = await axiosInstance.post(
      constants.apiName.changeLoginPassword, body);
    return response.data;
  } catch (error) {
    return error.data;
  }
}

async function removeEmployee(body) {
  try {
    let response = await axiosInstancesecond.post(
      constants.apiName.removeEmployee,
      body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function editEmployee(body) {
  try {
    let response = await axiosInstancesecond.post(
      constants.apiName.editEmployeeDetails,
      body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getCompanyDetails(body) {
  try {
    let response = await axiosInstance.get(
      constants.apiName.getCompanyDetails,
      body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function editCompany(body) {
  try {
    let response = await axiosInstance.post(
      constants.apiName.editCompanyDetails,
      body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function addHoliday(body) {
  try {
    const response = await axiosInstance.post(
      constants.apiName.addHoliday,
      body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getHoliday() {
  try {
    const response = await axiosInstancesecond.get(
      constants.apiName.getCompanyHoliday,
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function deleteCompanyHoliday(body) {
  try {
    const response = await axiosInstancesecond.post(
      constants.apiName.deleteHoliday,
      body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getHolidayInfo(id) {
  try {
    let response = await axiosInstancesecond.get(
      `${constants.apiName.getHolidayInformation}?holidayId=${id}`
    );
    return response.data;
  } catch (error) {
    return error.data;
  }
}

async function editCompanyHoliday(body) {
  try {
    const response = await axiosInstancesecond.put(
      constants.apiName.editHoliday,
      body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function changeEmpType(body) {
  try {
    const response = await axiosInstancesecond.put(
      constants.apiName.makeAdmin,
      body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getApprovers() {
  try {
    const response = await axiosInstancesecond.get(
      constants.apiName.selectApprovers,
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getApproversInEmployeeProfile(id) {
  try {
    const response = await axiosInstancesecond.get(
      `${constants.apiName.getApproversInProfile}?EmployeeUniqueId=${id}`
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function sendTokenForNotification(body) {
  try {
    const response = await axiosInstancesecond.post(
      constants.apiName.sendToken,
      body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getNotifications() {
  try {
    let response = await axiosInstancesecond.get(
      constants.apiName.getNotifications
    );
    return response.data;
  } catch (error) {
    return error.data;
  }
}

async function notificationPermission(body) {
  try {
    const response = await axiosInstancesecond.post(
      constants.apiName.notificationPermission,
      body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getEmployeeLeave(empId,duration,leaveType) {
  try {
    let response = await axiosInstancesecond.get(
      `${constants.apiName.getEmployeeLeave}?employeeId=${empId}&duration=${duration}&type=${leaveType}`
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}
async function getEmployeeLeaveReason(body) {
  try {
    let response = await axiosInstancesecond.post(constants.apiName.getEmpLeaveReason ,body);
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function fetchCompanyLogo() {
  try {
    let response = await axiosInstancesecond.get(
     constants.apiName.fetchCompanyLogoDetails
    );
    return response.data;
  } catch (error) {
    return error.data;
  }
}

async function updateCompanyLogo(logoFile) {
  try {
    const formData = new FormData();
    formData.append("files",logoFile);
    let response = await axiosInstancesecond.post(constants.apiName.updateCompanyLogo ,formData);
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getAttendanceRequest() {
  try {
    const response = await axiosInstanceThird.get(
      constants.apiName.getRequestAttendance,
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function previewAttendanceRequest(body) {
  try {
    const response = await axiosInstanceThird.post(
      constants.apiName.previewAttendanceRequest, body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getAttendanceRequestCount() {
  try {
    const response = await axiosInstanceThird.get(
      constants.apiName.getRequestAttendanceCount,
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getCompanyAttendanceData(date) {
  try {
    const response = await axiosInstancesecond.get(
      `${constants.apiName.exportCompanyLevelReport}?date=${date}`
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function exportEmployeeAttendance(empId ,startDate , endDate){
  try{
    const response = await axiosInstancesecond.get(
      `${constants.apiName.exportEmployeeLevelReportAttendance}?employeeId=${empId}&startDate=${startDate}&endDate=${endDate}`
    );
    return (response.data ? response.data : response);
  }
  catch(error){
    return (error.data ? error.data : error);
  }
}

async function applyLeave(body) {
  try {
    const response = await axiosInstancesecond.post(
      constants.apiName.applyEmployeeLeave, body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function createBroadcast(body) {
  try {
    const response = await axiosInstancesecond.post(
      constants.apiName.createBroadcast, body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function uploadBroadcastPhoto(id, photos) {
  try {
    const formData = new FormData();
    if (Array.isArray(photos)) {
      photos.forEach((photo) => {
        if (photo) {
          formData.append(constants.strings.filesLabel, photo);
        }
      });
    } else if (photos) {
      formData.append(constants.strings.filesLabel, photos);
    }

    formData.append(constants.strings.idToSave, id);

    let response = await axiosInstancesecond.post(constants.apiName.photoBroadcast, formData);
    return response.data ? response.data : response;
  } catch (error) {
    return error.data ? error.data : error;
  }
}

async function getBroadcastHistory() {
  try {
    const response = await axiosInstancesecond.get(
      constants.apiName.getBroadcastDetails,
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getBroadcastDetails(id) {
  try {
    const response = await axiosInstancesecond.get(
      `${constants.apiName.getBroadcastInfo}?broadcastId=${id}`,
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getRaiseDispute() {
  try {
    const response = await axiosInstancesecond.get(
      constants.apiName.getRaisedDisputes
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function actionDispute(body) {
  try {
    const response = await axiosInstancesecond.post(
      constants.apiName.performAction , body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}


async function fetchEmployeeList() {
  try {
      const response = await axiosInstancesecond.get(
      `${constants.apiName.getEmployeeList}`,
    );
    return (response.data ? response.data : response);
  } catch (error) {
     return (error.data ? error.data : error);
  }
}

async function markAttendance(body) {
  try {
    const response = await axiosInstanceThird.post(
      constants.apiName.markAttendance , body
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function getCompanySettingList() {
  try {
      const response = await axiosInstanceThird.get(
      `${constants.apiName.getCompanySettings}`,
    );
    return (response.data ? response.data : response);
  } catch (error) {
     return (error.data ? error.data : error);
  }
}

async function updateCompanySetting(body) {
  try {
      const response = await axiosInstanceThird.post(
      constants.apiName.updateCompanySetting , body
    );
    return (response.data ? response.data : response);
  } catch (error) {
     return (error.data ? error.data : error);
  }
}

async function verifyGenerateProductToken(body) {
  try {
      const response = await axiosInstance.post(
      constants.apiName.verifyGeneratedToken , body
    );
    return (response.data ? response.data : response);
  } catch (error) {
     return (error.data ? error.data : error);
  }
}

async function validateProductToken(body) {
  try {
      const response = await axiosInstance.post(
      constants.apiName.validateProductToken , body
    );
    return (response.data ? response.data : response);
  } catch (error) {
     return (error.data ? error.data : error);
  }
}

async function synchroniseEmployeeData() {
  try {
       const response = await axiosInstancesecond.get(
      `${constants.apiName.fetchEmployeeDetails}`,
    );
    return (response.data ? response.data : response);
  } catch (error) {
    return (error.data ? error.data : error);
  }
}

async function importOrUpdateSynchroniseUsers(body) {
  try {
      const response = await axiosInstancesecond.post(
      constants.apiName.synchronizeUsers , body
    );
    return (response.data ? response.data : response);
  } catch (error) {
     return (error.data ? error.data : error);
  }
}

const api = {
  companyProfile,
  googleAutoComplete,
  adminProfileRegistration,
  officeTiming,
  showEmployeeAttendance,
  getEmployeeStatus,
  uploadAdminProfile,
  logout,
  addEmployee,
  addEmpProfileUpload,
  adminProfileUpload,
  getEmployeeInformation,
  changeLoginPassword,
  removeEmployee,
  editEmployee,
  getCompanyDetails,
  editCompany,
  addHoliday,
  getHoliday,
  deleteCompanyHoliday,
  getHolidayInfo,
  editCompanyHoliday,
  changeEmpType,
  getApprovers,
  getApproversInEmployeeProfile,
  sendTokenForNotification,
  getNotifications,
  notificationPermission,
  companyLogo,
  getEmployeeLeave,
  getEmployeeLeaveReason,
  fetchCompanyLogo,
  updateCompanyLogo,
  getAttendanceRequest,
  previewAttendanceRequest,
  getAttendanceRequestCount,
  getCompanyAttendanceData,
  exportEmployeeAttendance,
  applyLeave,
  createBroadcast,
  uploadBroadcastPhoto,
  getBroadcastHistory,
  getBroadcastDetails,
  getRaiseDispute,
  actionDispute,
  fetchEmployeeList,
  markAttendance,
  getCompanySettingList,
  updateCompanySetting,
  verifyGenerateProductToken,
  validateProductToken,
  synchroniseEmployeeData,importOrUpdateSynchroniseUsers
};
export default api;